<template>
  <div class="user_mini_card" @click="handleUserCardClick">
    <div class="user_avatar">
      <img :src="user.headImage" />
    </div>
    <div class="user_info">
      <div class="info_name">
        <div class="info_nick text_ellipsis_1">
          {{ user.nickName }}
        </div>
        <div class="info_platform">({{ user.platform }})</div>
      </div>
      <div class="info_phone">
        {{ user.phone === "0" ? "未绑定手机号" : user.phone }}
      </div>
    </div>

    <Icon
      v-if="showRemove"
      class="user_remove"
      icon="icon-shanchu"
      @click="handleRemoveUserClick"
    />

    <div v-if="checked" class="user_checked_icon">
      <Icon class="checked_icon" icon="icon-ok" />
    </div>
  </div>
</template>

<script>
export default {
  name: "UserMiniCard",
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    showRemove: { type: Boolean, default: false },
    showChecked: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleUserCardClick() {
      if (this.showChecked && !this.checked) this.$emit("checked", this.user);
    },
    handleRemoveUserClick() {
      if (this.showRemove) this.$emit("remove", this.user);
    },
  },
};
</script>

<style lang="scss" scoped>
.user_mini_card {
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: #fafafb;
  padding: 5px;
  cursor: pointer;
  border: 1px solid #eee;
  border-radius: 5px;
  transition: all 0.2s;

  .user_avatar {
    margin-right: 10px;
    img {
      width: 50px;
      height: 50px;
      border-radius: 4px;
    }
  }
  .user_info {
    .info_name {
      display: flex;
      margin-bottom: 5px;
      .info_nick {
        margin-right: 2px;
      }
      .info_platform {
        min-width: 100px;
      }
    }
  }

  .user_remove {
    position: absolute;
    top: -5px;
    right: -5px;
    color: #fff;
    background-color: #ff0000;
    border-radius: 50%;
    font-size: 20px;
  }

  .user_checked_icon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    .checked_icon {
      font-size: 40px;
    }
  }

  &:hover {
    background-color: #6b6b6b;
    color: #fff;
  }
}
</style>
